const Url = {
  // baseUrl : "https://api.saawariyabook.com/api"
  // baseUrl : "https://api.saawariyabook.com/api"
  baseUrl: "https://api.rana365.online/api",
};
export default Url;



// WEBPACK FOOTER //
// ./src/components/configure/configure.js